import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { hasRequiredItem } from 'src/libs/util'
import { Result, Button } from 'antd'
import Link from 'next/link'
import { getUser } from 'src/libs/browser'

export function RouteValidator ({ requiredPermissions, requiredRoles, children, statusCode }) {
  const { t } = useTranslation()
  const { userPermissions, userRoles } = getUser()
  const [isVisible, setVisible] = useState(hasRequiredItem(userPermissions, requiredPermissions) || hasRequiredItem(userRoles, requiredRoles))
  const status = useRef({ codeStr: '403', subTitile: t('common.text.unauthorized') })

  useEffect(() => {
    if (isVisible && statusCode >= 400) {
      status.current.codeStr = statusCode >= 500 ? '500' : statusCode >= 400 && statusCode !== 403 ? '404' : '403'
      const codeStr = status.current.codeStr
      status.current.subTitile = codeStr === '403' ? t('common.text.unauthorized') : codeStr === '500' ? t('common.text.server_error') : t('common.text.not_found')
      setVisible(false)
    }
  }, [statusCode])

  if (isVisible) {
    return children
  }
  const { codeStr, subTitile } = status.current
  return (
    <Result
      status={codeStr}
      title={codeStr}
      subTitle={subTitile}
      extra={<Button type='primary'><Link href='/dashboard'>{t('common.text.back_home')}</Link></Button>}
    />
  )
}
